import { render, staticRenderFns } from "./LoyaltyPosts.vue?vue&type=template&id=1ecc8fd6&scoped=true&"
import script from "./LoyaltyPosts.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecc8fd6",
  null
  
)

export default component.exports